import type { WorkspaceMember } from '@/types/workspace';
import { getMemberLabel } from './getMemberLabel';

/**
 * Resolve a workspace member's userId to a display label — displayName, falling
 * back to email, then the raw id. Shared by filter pills that render selected
 * members by name.
 */
export function resolveMemberLabel(
  members: readonly WorkspaceMember[],
  userId: string
): string {
  const match = members.find((member) => member.userId === userId);
  return match ? getMemberLabel(match) : userId;
}

/**
 * Resolve a list of member userIds to a single comma-joined display label
 * (each via resolveMemberLabel). Returns null when the list is empty, so callers
 * can skip rendering a pill. Shared by the task assignee and note author filter
 * pills.
 */
export function resolveMemberLabels(
  members: readonly WorkspaceMember[],
  userIds: readonly string[]
): string | null {
  if (userIds.length === 0) return null;
  return userIds
    .map((userId) => resolveMemberLabel(members, userId))
    .join(', ');
}
